import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { DolbyService } from '../../services/dolby/dolby.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { RecordingsService } from '../../services/recordings/recordings.service';
import { Subscription, firstValueFrom } from 'rxjs';
import { Session, Take } from '@sc/types';
import { DescriptService } from '../../services/descript/descript.service';
import { defaultPopoverOptions } from '../../services/theme/theme.service';
import { LeaveSessionMenuComponent } from '../leave-session-menu/leave-session-menu.component';
import { DailyService } from '../../services/daily/daily.service';

@Component({
  selector: 'sc-take-select-menu',
  templateUrl: './take-select-menu.component.html',
  styleUrls: ['./take-select-menu.component.scss'],
})
export class TakeSelectMenuComponent implements OnInit, OnDestroy {
  @Input() session: Session;
  @Input() click: any;
  dolbyConversation$ = this.dolbyService.dolbyConversation$;
  dailyCall$ = this.dailyService.dailyCall$;
  takes: Take[];
  subs: Subscription[] = [];

  constructor(
    private popoverController: PopoverController,
    private dolbyService: DolbyService,
    private dailyService: DailyService,
    private analyticsService: AnalyticsService,
    private recordingsService: RecordingsService,
    private descriptService: DescriptService
  ) {}

  ngOnInit() {
    const sub = this.recordingsService.getTakesFromSession(this.session.sessionID).subscribe((takes) => {
      this.takes = takes;
    });

    this.subs.push(sub);
  }

  /**
   * Reopens the Leave Session menu
   */
  async goBack() {
    await this.popoverController.dismiss();
    const menu = await this.popoverController.create({
      ...defaultPopoverOptions,
      component: LeaveSessionMenuComponent,
      componentProps: {
        session: this.session,
        click: this.click,
      },
      cssClass: 'leave-session-menu',
      event: this.click,
    });
    await menu.present();
  }

  /**
   * Sends recordings from selected take to Edit in Descript
   *
   * @param selectedTake
   */
  async selectTake(selectedTake: Take) {
    const recordingsFromTake = await firstValueFrom(
      this.recordingsService.getAllRecordingsFromTake(selectedTake.sessionID, selectedTake.takeNumber)
    );
    this.descriptService.editInDescript(recordingsFromTake);
    await this.popoverController.dismiss();

    if (this.session.confType !== 'daily' || this.dolbyConversation$.value) {
      await this.dolbyService.leaveConversation();
    }

    if (this.session.confType === 'daily' || this.dailyCall$.value) {
      await this.dailyService.leaveCall();
    }

    await this.analyticsService.track('left recording session');
  }

  ngOnDestroy() {
    this.subs.map((sub) => sub.unsubscribe());
  }
}
